const labelByItem = {
  partners: 'Partners',
  tickets: 'Tickets',
  arena: 'Arena',
  shop: 'Shop',
  rollCraft: 'Games',
} as const;

export { labelByItem };
